export const selectorGetSimulationSpeed = (state) => state.init.simulationSpeed;
export const selectorGetSmoothArray = (state) => state.init.smoothArray;
export const selectorGetTickDuration = (state) => state.init.tickDuration;
export const selectorGetDataset = (state) => state.init.dataset;
export const selectorGetActiveStream = (state) => state.init.activeStream;
export const selectorGetTradePosts = (state) => state.init.trade_posts;
